module.exports = __webpack_public_path__ + "static/media/great-place-to-work-2024-25.5ec12440.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/great-place-to-work-2024-25.webp
// module id = 130
// module chunks = 0